import WorkerApiService from "../../workerApiServices";

class FolhaDePagamentoService extends WorkerApiService {

    constructor() {
        super('/api/folhaDePagamento')
    }

    // getUploadResult(progressKey){
    //     let params = `?`
    //     params = `${params}&progressKey=${progressKey}`
    //     return this.get(`/getUploadResult${params}`)
    // }

    getRelatorio(dataInicial, dataFinal, tipoProcessoFolhaDePagamento){
        let params = `?`
        params = `${params}&dataInicial=${dataInicial}`
        params = `${params}&dataFinal=${dataFinal}`
        params = `${params}&tipoProcessoFolhaDePagamento=${tipoProcessoFolhaDePagamento}`
        return this.get(`/getRelatorio${params}`)
    }    

    deleteFolhaDePagamento(object){
        return this.post("/delete", object)
    }

}

export default FolhaDePagamentoService